import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row, Upload } from "antd";
import { getMediaUrl } from "config/env";
import { getBase64 } from "functions/functions";
import Loading from "layouts/Loading/Loading";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Axios from "middleware/axiosInstance";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AddAndEditImageGallery = () => {
  // start react router url params
  const UrlParams = useParams();
  const { imageGalleryId } = UrlParams;
  const isInEditMode = imageGalleryId ? true : false;
  // end react router url params
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [imageGalleryInfoForEdit, setImageGalleryInfoForEdit] = useState(null);

  // upload image
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // end of upload image

  const SubmitNewImageGallery = async (imageGallery) => {
    if (fileList[0]) {
      imageGallery.image = await getBase64(fileList[0].originFileObj);
    }
    Axios.post("/image-gallery", imageGallery)
      .then((res) => {
        navigate("/image-galleries");
        OpenNotificationWithIcon("ثبت موفق", "با موفقیت افزوده شد");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isInEditMode) {
      getImageGalleryInfoForEdit();
    }
  }, []);

  const getImageGalleryInfoForEdit = () => {
    Axios.get(`/image-gallery/${imageGalleryId}`)
      .then((res) => {
        setImageGalleryInfoForEdit(res.data);
        if (res.data.image) {
          setFileList([{
            "thumbUrl": getMediaUrl(res.data.image),
            "preview": getMediaUrl(res.data.image)
          }]);
        }
      })
      .catch((err) => console.log(err));
  };

  const imageGalleryEditHandler = async (imageGallery) => {
    if (fileList[0]) {
      if (fileList[0].originFileObj) {
        imageGallery.image = await getBase64(fileList[0].originFileObj);
      } else {
        delete imageGallery.image;
      }
    } else {
      imageGallery.image = null;
    }
    Axios.put(`/image-gallery/${imageGalleryId}`, imageGallery)
      .then((res) => {
        navigate("/image-galleries");
        OpenNotificationWithIcon("ویرایش موفق", "با موفقیت ویرایش شد");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          {isInEditMode ? `ویرایش تصویر گالری ${imageGalleryInfoForEdit?.title_fa}` : "افزودن تصویر گالری"}
        </h5>
        {isInEditMode && imageGalleryInfoForEdit === null ? (
          <Loading />
        ) : (
          <Form
            layout="vertical"
            initialValues={imageGalleryInfoForEdit}
            form={form}
            autoComplete="off"
            scrollToFirstError
            labelCol={{ xs: 24 }}
            onFinish={isInEditMode ? imageGalleryEditHandler : SubmitNewImageGallery}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="عنوان فارسی"
                  name="title_fa"
                  rules={[
                    {
                      required: true,
                      message: "عنوان فارسی الزامی می باشد",
                    },
                  ]}
                >
                  <Input placeholder="عنوان فارسی" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="عنوان انگلیسی"
                  name="title_en"
                  rules={[
                    {
                      required: true,
                      message: "عنوان انگلیسی الزامی می باشد",
                    },
                  ]}
                >
                  <Input placeholder="English Title" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  label="عنوان عربی"
                  name="title_ar"
                  rules={[
                    {
                      required: true,
                      message: "عنوان عربی الزامی می باشد",
                    },
                  ]}
                >
                  <Input placeholder="العنوان العربي" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item name="image" label="تصویر">
                  <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    beforeUpload={() => false}
                    maxCount={5}
                  >
                    {fileList.length >= 1 ? null : uploadButton}
                  </Upload>
                </Form.Item>
                <Modal
                  open={previewOpen}
                  title={previewTitle}
                  footer={null}
                  onCancel={handleCancel}
                >
                  <img
                    alt="example"
                    style={{
                      width: "100%",
                    }}
                    src={previewImage}
                  />
                </Modal>
              </Col>

              <Col xs={24}>
                <Button htmlType="submit" type="primary">
                  {isInEditMode ? "ثبت تغییرات" : "افزودن"}
                </Button>
                <Button
                  className="me-3"
                  onClick={() => navigate("/image-galleries")}
                  style={{ marginRight: 8 }}
                >
                  بازگشت
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </div>
    </div>
  );
};

export default AddAndEditImageGallery;

